import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useMockPortal } from '../mock/useMockPortal';
import { formatPortalCurrency, formatPortalDate } from '../mock/store';

const LoanHistory: React.FC = () => {
  const { history } = useMockPortal();

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Payment history
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        Recent payments and credits on this loan (sample data).
      </Typography>

      <Paper variant="outlined" sx={{ overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="right">Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {history.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{formatPortalDate(row.date)}</TableCell>
                <TableCell>{row.description}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell align="right">
                  {formatPortalCurrency(row.amount)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
};

export default LoanHistory;
